import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { deleteVehicle } from 'actions/vehicles'
import { DrivingProfile } from 'types/profile'
import { VehicleFormStates } from 'util/vehicle'

type UseHandleCancelVehicleProps = {
  vehicleId?: number
  newVehicleFlow: boolean
  setFormState?: React.Dispatch<React.SetStateAction<VehicleFormStates | null>>
}

export const useHandleCancelVehicle = ({ vehicleId, newVehicleFlow, setFormState }: UseHandleCancelVehicleProps) => {
  const profile = useSelector<any, DrivingProfile>((state) => state.profile)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleCancel = useCallback(async () => {
    if (newVehicleFlow) {
      await deleteVehicle(vehicleId, profile.id)(dispatch)
      history.push('/account/driving-info')
    } else {
      setFormState?.(null)
      return
    }
  }, [dispatch, profile.id, newVehicleFlow, vehicleId, setFormState, history])

  return handleCancel
}
